import { supabase } from "@/integrations/supabase/client";

const COOKIE_NAME = "qsg_ref";

function setCookie(name: string, value: string, days: number) {
  const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
  document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Lax`;
}

export function getAffiliateCookie(): string | null {
  const match = document.cookie.match(new RegExp(`(?:^|; )${COOKIE_NAME}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
}

/** Run on every page load. If ?ref=CODE in URL, set 30-day cookie & log click. */
export async function trackAffiliateReferral() {
  try {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("ref");
    if (!code) return;
    const upper = code.trim().toUpperCase();
    if (!/^[A-Z0-9]{4,32}$/.test(upper)) return;

    setCookie(COOKIE_NAME, upper, 30);

    await supabase.functions.invoke("track-affiliate-click", {
      body: {
        code: upper,
        landing_page: window.location.pathname + window.location.search,
        referrer: document.referrer || null,
      },
    });
  } catch (e) {
    console.warn("Affiliate tracking failed:", e);
  }
}
